import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function AC_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <AC_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <AC_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function AC_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What industries use AutoCAD?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              AutoCAD is widely used across various industries, including
              architecture, engineering (civil, mechanical, electrical),
              construction, manufacturing, and interior design. Its versatility
              allows professionals to create detailed 2D and 3D drawings and
              models.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills are necessary for a career using AutoCAD?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Essential skills include proficiency in AutoCAD software,
              understanding of technical drawing and design principles,
              attention to detail, spatial awareness, problem-solving skills,
              and knowledge of industry standards and regulations.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What types of jobs can I get with AutoCAD skills?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Jobs that require AutoCAD skills include CAD Technician,
              Architectural Draftsperson, Mechanical Designer, Civil Engineer,
              Interior Designer, and Construction Project Manager. Many roles
              may also require additional industry-specific qualifications.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Is AutoCAD certification worth it?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Yes, obtaining an AutoCAD certification can enhance your job
              prospects and demonstrate your proficiency to employers. It can
              also lead to potential salary increases and opportunities for
              career advancement.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How can I improve my AutoCAD skills?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              To improve your AutoCAD skills, consider taking formal courses
              (online or in-person), practicing with real-world projects,
              utilizing online tutorials and resources, joining user groups or
              forums, and seeking feedback on your work from experienced
              professionals.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default AC_FAQ_page
